import BaseStore from '../../BaseStore';
import TicketActionModel from '../../../models/Maintenance/Ticket/TicketActionModel';

class TicketActionStore extends BaseStore {
  constructor(transportLayer) {
    super(TicketActionModel, transportLayer);
  }
}

export default TicketActionStore;



// WEBPACK FOOTER //
// ./src/stores/Maintenance/Ticket/TicketActionStore.js